import { apiClient, apiOrigin, type RequestOptions } from '@/services/apiClient';

export type AiProviderKey = 'anthropic' | 'openai';

export interface AiProviderStatus {
  key: AiProviderKey;
  configured: boolean;
  healthy: boolean;
  detail: string | null;
  source?: 'platform' | 'workspace' | 'disabled';
  model?: string;
  verified?: boolean;
  authenticationVerified?: boolean;
  checkKind?: 'authentication';
  generationTested?: false;
  failureCode?: string;
  httpStatus?: number;
  checkedAt?: string | null;
}

export interface AiRouteStatus {
  taskClass: string;
  chain: AiProviderKey[];
  source: 'explicit' | 'default' | 'implicit';
  executionPath?: 'document_service';
  readiness?: 'unknown' | 'blocked';
  policyAllowed?: boolean;
  detail?: string;
}

export interface AiStatusReport {
  providers: AiProviderStatus[];
  routes: AiRouteStatus[];
  invocationsLast24h: Record<string, number>;
  roles: { businessText: 'anthropic'; voice: 'openai'; images: 'openai' };
}

async function getStatus(options?: RequestOptions): Promise<AiStatusReport> {
  const result = await apiClient.get<AiStatusReport>(`${apiOrigin}/api/v1/ai/status`, options);
  if (!result.ok || !result.data) {
    throw new Error(result.error ?? 'Unable to load AI provider status');
  }
  return result.data;
}

export const aiClient = { getStatus };
